module.exports = __webpack_public_path__ + "static/media/subscribers.f4a7d1fc.svg";